import { HitAllResult } from '@/components/search/types';
import { CardInfo } from '@/components/types';
import { mapPictureHit } from './mapPictureHit';
import { mapVideoHit } from './mapVideoHit';
import { mapGenericHit } from './mapGenericHit';
import { mapAssetHit } from './mapAssetHit';
import { TableAssetItemProps } from '@/components/table/TableAssetItem';

export function mapGlobalHit(hit: HitAllResult): CardInfo | TableAssetItemProps {
  switch (hit.type) {
    case 'youtube_videos':
      return mapVideoHit(hit);
    case 'ffbbnational_galeries':
      return mapPictureHit(hit);
    case 'directus_files':
      return mapAssetHit(hit);
    default:
      return mapGenericHit(hit);
  }
}
